import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

var ChevronLeftSmall = function ChevronLeftSmall(props) {
  var rtlStyle = {
    transform: 'scale(-1, 1)'
  };
  var _props$color = props.color,
      color = _props$color === void 0 ? 'currentColor' : _props$color,
      size = props.size,
      _props$dir = props.dir,
      dir = _props$dir === void 0 ? 'ltr' : _props$dir,
      style = props.style;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: dir === 'rtl' ? _extends({}, style, rtlStyle) : _extends({}, style)
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7364 17.7364C15.0878 17.3849 15.0878 16.815 14.7364 16.4636L10.2728 12L14.7364 7.53636C15.0878 7.18489 15.0878 6.61504 14.7364 6.26357C14.3849 5.9121 13.815 5.9121 13.4636 6.26357L8.36358 11.3636C8.01211 11.7151 8.01211 12.2849 8.36358 12.6364L13.4636 17.7364C13.8151 18.0878 14.3849 18.0878 14.7364 17.7364Z",
    fill: color
  }));
};

export { ChevronLeftSmall };
